import React, { useEffect, useState } from 'react'
import ModalWrapper from '../../../../../../Components/CustomModal/ModalWrapper'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import axios from 'axios';
import { V_URL } from '../../../../../../BaseUrl';
import { Pencil, Save, Trash2, X } from 'lucide-react';
import { MultiSelect } from 'primereact/multiselect';
import { getPurBillNo } from '../../../../../../Store/prosafe/proTransaction/PurReturn/getPuBillNo';
import { getPurChallanNo } from '../../../../../../Store/prosafe/proTransaction/PurReturn/getPuChallanNo';
import { getFilterItems } from '../../../../../../Store/prosafe/proTransaction/PurReturn/getFilterItems';
import { getViewReturnItems } from '../../../../../../Store/prosafe/proTransaction/PurReturn/getViewReturnItems';

const AutoReturnModel = ({ modal, setItemsArr, itemsArr, form, setForm, data }) => {

  const dispatch = useDispatch();
  const [autoItemsData, setAutoItemsData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [filter, setFilter] = useState({
    billNo: [],
    challanNo: [],
  });

  const billNoData = useSelector((state) => state.getPurBillNo?.user?.data);
  const challanNoData = useSelector((state) => state.getPurChallanNo?.user?.data);
  const filterItemsData = useSelector((state) => state.getFilterItems?.user?.data);  

  useEffect(() => {
    if (form.party_id) {
      const formData = new URLSearchParams();
      formData.append("tag_number", 11);
      formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"))
      formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
      formData.append('party_id', form.party_id);
      dispatch(getPurBillNo({ formData }));
      dispatch(getPurChallanNo({ formData }))
    }
  }, [modal, form.party_id]);

  useEffect(() => {
    if (form.party_id) {
      const formData = new URLSearchParams();
      formData.append("tag_number", 11);
      formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"))
      formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
      formData.append('party_id', form.party_id);
      formData.append("bill_no", JSON.stringify(filter.billNo));
      formData.append("challan_no", JSON.stringify(filter.challanNo));
      dispatch(getFilterItems({ formData }));
    }
  }, [filter.billNo, filter.challanNo, form.party_id, modal]);

  const recalculate = (item) => {
    const { quantity = 0, rate = 0, gst = 0, discount = 0, sp_discount = 0 } = item;
    const amount = quantity * rate;
    const discount_amount = (amount * discount) / 100;
    const sp_discount_amount = ((amount - discount_amount) * sp_discount) / 100;
    const taxable_amount = amount - discount_amount - sp_discount_amount;
    const gst_amount = (taxable_amount * gst) / 100;
    const total_amount = taxable_amount + gst_amount;
    return { ...item, amount, discount_amount, sp_discount_amount, taxable_amount, gst_amount, total_amount };
  };

  useEffect(() => {
    if (!modal.isShown) {
      setAutoItemsData([]);
      setOriginalData([]);
      setIsEditing(false);
    }
  }, [modal.isShown]);

  useEffect(() => {
    if (Array.isArray(filterItemsData)) {
      const mappedItems = filterItemsData?.filter(e => {
        return !itemsArr?.some(item =>
          item.from_id === e?.from_id &&
          item.detail_id === e?.detail_id &&
          item.item_id === e?.item_data?._id
        );
      })?.map((e) => {
        const qty = e.quantity || 0;
        const rate = e.rate || 0;
        const gst = e.gst || 0;
        const base = {
          ...e,
          item: e.item_data?.name,
          item_id: e.item_data?._id,
          quantity: qty,
          rate: rate,
          gst: gst,
          discount: 0,
          sp_discount: 0,
          remarks: '',
          isAuto: true,
        };
        return recalculate(base);
      });
      setAutoItemsData(mappedItems);
      setOriginalData(mappedItems);
    }
  }, [filterItemsData, itemsArr]);

  const handleSubmit = async () => {
    const hasInvalid = autoItemsData?.some((item) => {
      return (
        !item.rate || item.rate <= 0
      );
    });
    if (hasInvalid) {
      toast.error("Please fill all required fields: Receiving Qty, Rate, and Heat No. for each item.");
      return;
    }

    const billNos = [...new Set(autoItemsData?.map(item => item.pu_bill_no).filter(Boolean))];
    const challanNos = [...new Set(autoItemsData?.map(item => item.pu_challan_no).filter(Boolean))];

    const currentBillNos = form.bill_no
      ? form.bill_no.split(',').map(s => s.trim()).filter(Boolean)
      : [];

    const currentChallanNos = form.challan_no
      ? form.challan_no.split(',').map(s => s.trim()).filter(Boolean)
      : [];

    const mergedBillNos = [...new Set([...currentBillNos, ...billNos])];
    const mergedChallanNos = [...new Set([...currentChallanNos, ...challanNos])];

    setForm(prev => ({
      ...prev,
      bill_no: mergedBillNos.join(', '),
      challan_no: mergedChallanNos.join(', ')
    }));

    const updatedItems = autoItemsData.map((item) => ({
      from_id: item.from_id,
      detail_id: item.detail_id,
      item_id: item.item_id,
      item_no: item.item_no,
      item_length: item.item_length,
      item_width: item.item_width,
      item_weight: item.item_weight,
      item_radius: item.item_radius,
      item_thickness: item.item_thickness,
      assembly_weight: item.assembly_weight,
      assembly_surface_area: item.assembly_surface_area,
      heat_no: item.heat_no,
      plat_no: item.plat_no,
      tc_no: item.tc_no,
      quantity: item.quantity,
      rate: item.rate,
      amount: item.amount,
      discount: item.discount,
      discount_amount: item.discount_amount,
      sp_discount: item.sp_discount,
      sp_discount_amount: item.sp_discount_amount,
      taxable_amount: item.taxable_amount,
      gst: item.gst,
      gst_amount: item.gst_amount,
      total_amount: item.total_amount,
      isAuto: item.isAuto,
    }))

    if (data?._id) {
      const payload = {
        id: data._id,
        items_details: JSON.stringify(updatedItems),
      };
      const resp = await axios.post(`${V_URL}/prosafe/pro-add-pur-item`, payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem('PAY_USER_TOKEN')}` },
      });
      if (resp.data.success) {
        toast.success(resp.data.message);
        dispatch(getViewReturnItems({ formData: { id: data._id } }));
        modal.hide();
      } else {
        toast.error(resp.data.message);
      }
    } else {
      setItemsArr(prev => [...prev, ...updatedItems]);
    }
    modal.hide();
    toast.success('Items added successfully');
  }

  return (
    <ModalWrapper
      title="Auto Items Details"
      isShown={modal.isShown}
      hide={modal.hide}
      footer={false}
      customSize={"modal-90w"}
    >
      <div className="row">
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Bill No.</label>
            <MultiSelect
              value={filter.billNo}
              options={billNoData?.map(e => ({ label: e.bill_no || "N/A", value: e.bill_no }))}
              onChange={(e) => setFilter({ ...filter, billNo: e.value })}
              placeholder="Select Bill No."
              className="w-100"
            />
          </div>
        </div>
        <div className="col-12 col-md-4 col-xl-4">
          <div className="input-block local-forms custom-select-wpr">
            <label>Challan No.</label>
            <MultiSelect
              value={filter.challanNo}
              options={challanNoData?.map(e => ({ label: e.challan_no, value: e.challan_no }))}
              onChange={(e) => setFilter({ ...filter, challanNo: e.value })}
              placeholder="Select Challan No."
              className="w-100"
            />
          </div>
        </div>
      </div>

      <div className='row'>
        <div className="table-responsive">
          <table className="table border-0 custom-table comman-table mb-0">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Item Name</th>
                <th>Item No</th>
                <th>Length</th>
                <th>Width</th>
                <th>Weight</th>
                <th>Radius</th>
                <th>Thickness</th>
                <th>Assembly Weight</th>
                <th>Surface Area</th>
                <th>Heat/Lot No.</th>
                <th>Plat No.</th>
                <th>TC No.</th>
                <th>Return Qty</th>
                <th>Rate(₹)</th>
                <th>Amount(₹)</th>
                <th>Discount(%)</th>
                <th>Discount Amount(₹)</th>
                <th>Sp. Discount(%)</th>
                <th>Sp. Discount Amount(₹)</th>
                <th>Taxable Amount(₹)</th>
                <th>GST(%)</th>
                <th>GST Amount(₹)</th>
                <th>Total Amount(₹)</th>
                <th>Remarks</th>
                <th className='text-end'>Action</th>
              </tr>
            </thead>
            <tbody>
              {autoItemsData?.map((elem, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{elem?.item}</td>
                  <td>{elem?.item_no}</td>
                  <td>{elem?.item_length}</td>
                  <td>{elem?.item_width}</td>
                  <td>{elem?.item_weight}</td>
                  <td>{elem?.item_radius}</td>
                  <td>{elem?.item_thickness}</td>
                  <td>{elem?.assembly_weight}</td>
                  <td>{elem?.assembly_surface_area}</td>
                  <td>{elem?.heat_no || "-"}</td>
                  <td>{elem?.plat_no || "-"}</td>
                  <td>{elem?.tc_no || "-"}</td>
                  <td>{elem?.quantity}</td>
                  <td>
                    {isEditing ? (
                      <input type="number" className="form-control table-input"
                        value={elem.rate} onChange={(e) => {
                          const updated = [...autoItemsData];
                          updated[i].rate = parseFloat(e.target.value) || 0;
                          updated[i] = recalculate(updated[i]);
                          setAutoItemsData(updated);
                        }}
                      />
                    ) : elem.rate}
                  </td>
                  <td>{elem.amount?.toFixed(2)}</td>
                  <td>
                    {isEditing ? (
                      <input type="number" className="form-control table-input"
                        value={elem.discount} onChange={(e) => {
                          const updated = [...autoItemsData];
                          updated[i].discount = parseFloat(e.target.value) || 0;
                          updated[i] = recalculate(updated[i]);
                          setAutoItemsData(updated);
                        }}
                      />
                    ) : elem.discount}
                  </td>
                  <td>{elem.discount_amount?.toFixed(2)}</td>
                  <td>
                    {isEditing ? (
                      <input type="number" className="form-control table-input"
                        value={elem.sp_discount} onChange={(e) => {
                          const updated = [...autoItemsData];
                          updated[i].sp_discount = parseFloat(e.target.value) || 0;
                          updated[i] = recalculate(updated[i]);
                          setAutoItemsData(updated);
                        }}
                      />
                    ) : elem.sp_discount}
                  </td>
                  <td>{elem.sp_discount_amount?.toFixed(2)}</td>
                  <td>{elem.taxable_amount?.toFixed(2)}</td>
                  <td>
                    {isEditing ? (
                      <input type="number" className="form-control table-input"
                        value={elem.gst} onChange={(e) => {
                          const updated = [...autoItemsData];
                          updated[i].gst = parseFloat(e.target.value) || 0;
                          updated[i] = recalculate(updated[i]);
                          setAutoItemsData(updated);
                        }}
                      />
                    ) : elem.gst}
                  </td>
                  <td>{elem.gst_amount?.toFixed(2)}</td>
                  <td>{elem.total_amount?.toFixed(2)}</td>
                  <td>
                    {isEditing ? (
                      <textarea rows={1} className="form-control table-input" value={elem.remarks}
                        style={{ width: "150px" }} onChange={(e) => {
                          const updated = [...autoItemsData];
                          updated[i].remarks = e.target.value;
                          setAutoItemsData(updated);
                        }}
                      />
                    ) : elem.remarks || "-"}
                  </td>
                  <td className="d-flex justify-content-end">
                    <a className="action-icon p-1 mx-1" onClick={() => {
                      const filtered = autoItemsData?.filter((_, index) => index !== i);
                      setAutoItemsData(filtered);
                    }}>
                      <Trash2 />
                    </a>
                  </td>
                </tr>
              ))}
              {autoItemsData?.length === 0 ? (
                <tr>
                  <td colSpan="999">
                    <div className="no-table-data">
                      No Data Found!
                    </div>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
        <div className="mt-3 text-end">
          {isEditing ? (
            <>
              <button className="btn btn-success mx-2" onClick={() => setIsEditing(false)}>
                <Save className="me-1" /> Save
              </button>
              <button className="btn btn-secondary mx-2" onClick={() => {
                setAutoItemsData([...originalData]);
                setIsEditing(false);
              }}>
                <X className="me-1" /> Cancel
              </button>
            </>
          ) : (
            <button className="btn btn-outline-primary mx-2" onClick={() => setIsEditing(true)}>
              <Pencil className="me-1" /> Edit All
            </button>
          )}
          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </ModalWrapper>
  )
}

export default AutoReturnModel